import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["searchString", "createDateFilter", "lastActivityFilter"],
  _excluded2 = ["limit", "offset", "pollInterval"],
  _excluded3 = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { useEffect, useState } from 'react';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { generateDateFilter } from '../constants/filters';
import { TICKET_LISTINGS_PATH } from '../../api/paths';
import { getIsPreview } from '../utils/isPreview';
export const DEFAULT_LIMIT = 10;
export const GET_TICKET_LISTING_KEY = 'getTicketListings';
const getTicketListings = async _ref => {
  let {
      searchString,
      createDateFilter,
      lastActivityFilter
    } = _ref,
    variables = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isPreview
  } = getIsPreview();
  if (isPreview) {
    return {
      total: 0,
      hasMore: false,
      offset: 0,
      results: new Array(DEFAULT_LIMIT).fill(null).map((_, index) => ({
        hs_ticket_id: index + 1
      }))
    };
  }
  const response = await api(TICKET_LISTINGS_PATH, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(Object.assign({
      searchString: searchString === '' ? undefined : searchString,
      dateFilters: [generateDateFilter('createdate', createDateFilter), generateDateFilter('hs_lastactivitydate', lastActivityFilter)].filter(Boolean)
    }, variables))
  });
  return response.json();
};
export const GET_TICKET_LISTING = registerQuery({
  fieldName: GET_TICKET_LISTING_KEY,
  args: ['offset', 'limit', 'ticketView', 'statusFilter', 'searchString', 'sort', 'createDateFilter', 'lastActivityFilter'],
  fetcher: getTicketListings
});
export const useTicketListings = _ref2 => {
  var _data$GET_TICKET_LIST;
  let {
      limit = DEFAULT_LIMIT,
      offset,
      pollInterval = 15000
    } = _ref2,
    variables = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const [total, setTotal] = useState(0);
  const _useQuery = useQuery(GET_TICKET_LISTING, {
      variables: Object.assign({
        limit,
        offset
      }, variables),
      pollInterval,
      skipPollAttempt: () => document.visibilityState === 'hidden',
      onCompleted: result => {
        var _result$GET_TICKET_LI;
        if ((result === null || result === void 0 || (_result$GET_TICKET_LI = result[GET_TICKET_LISTING_KEY]) === null || _result$GET_TICKET_LI === void 0 ? void 0 : _result$GET_TICKET_LI.total) !== undefined) {
          setTotal(result[GET_TICKET_LISTING_KEY].total);
        }
      }
    }),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded3);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });

  // Reset the total when filters change
  useEffect(() => {
    setTotal(0);
  }, [variables.createDateFilter, variables.lastActivityFilter, variables.statusFilter, variables.ticketView, variables.searchString]);
  return Object.assign({
    data: data === null || data === void 0 || (_data$GET_TICKET_LIST = data[GET_TICKET_LISTING_KEY]) === null || _data$GET_TICKET_LIST === void 0 ? void 0 : _data$GET_TICKET_LIST.results,
    total,
    refetch,
    loading
  }, rest);
};